function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9C0 5.40486 0 3.60729 0.856692 2.31255C1.23925 1.73439 1.73439 1.23925 2.31255 0.856692C3.60729 0 5.40486 0 9 0C12.5951 0 14.3927 0 15.6874 0.856692C16.2656 1.23925 16.7608 1.73439 17.1433 2.31255C18 3.60729 18 5.40486 18 9C18 12.5951 18 14.3927 17.1433 15.6874C16.7608 16.2656 16.2656 16.7608 15.6874 17.1433C14.3927 18 12.5951 18 9 18C5.40486 18 3.60729 18 2.31255 17.1433C1.73439 16.7608 1.23925 16.2656 0.856692 15.6874C0 14.3927 0 12.5951 0 9ZM13.6596 8.99925C13.6596 11.5726 11.5736 13.6587 9.00023 13.6587C6.42691 13.6587 4.34082 11.5726 4.34082 8.99925C4.34082 6.42593 6.42691 4.33984 9.00023 4.33984C11.5736 4.33984 13.6596 6.42593 13.6596 8.99925ZM9.00023 12.0823C10.7029 12.0823 12.0832 10.7019 12.0832 8.99925C12.0832 7.29656 10.7029 5.91625 9.00023 5.91625C7.29753 5.91625 5.91723 7.29656 5.91723 8.99925C5.91723 10.7019 7.29753 12.0823 9.00023 12.0823ZM13.8436 5.20137C14.4483 5.20137 14.9385 4.7112 14.9385 4.10654C14.9385 3.50189 14.4483 3.01172 13.8436 3.01172C13.239 3.01172 12.7488 3.50189 12.7488 4.10654C12.7488 4.7112 13.239 5.20137 13.8436 5.20137Z",
  fill: "#FAF9FC"
});
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.472053bb07114c03101ea91d3782304c.svg";
export { ForwardRef as ReactComponent };